import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectSelector = ({ projects, selectedProject, onSelectProject }) => {
  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 mb-6">
      <label className="block text-sm font-medium text-foreground mb-3">
        Select Project
      </label>
      <div className="relative">
        <select
          value={selectedProject?.id || ''}
          onChange={(e) => {
            const project = projects?.find(p => p?.id === e?.target?.value);
            onSelectProject(project);
          }}
          className="w-full px-4 py-3 bg-input border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-ring appearance-none pr-10"
        >
          <option value="">Choose a project...</option>
          {projects?.map((project) => (
            <option key={project?.id} value={project?.id}>
              {project?.number} - {project?.name}
            </option>
          ))}
        </select>
        <Icon 
          name="ChevronDown" 
          size={20} 
          className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground"
        />
      </div>
      {selectedProject && (
        <div className="mt-4 p-4 bg-muted rounded-lg">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <p className="text-xs text-muted-foreground mb-1">Customer</p>
              <p className="text-sm font-medium text-foreground">{selectedProject?.customer}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Status</p>
              <p className="text-sm font-medium text-foreground capitalize">{selectedProject?.status}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Total Amount</p>
              <p className="text-sm font-medium text-foreground">
                ${selectedProject?.totalAmount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectSelector;